<template >
  <v-row no-gutters class="login-full ">
    <v-col cols="12" class=" pt-2 px-2 subtitle">Order</v-col>
    <v-col v-for="(item, i) in order" :key="i" cols="6" sm="6" md="3" lg="2" class="pa-1">
      <v-card :color="item.color" dark>
        <div class="d-flex pointer" @click="changeRouter(item.value)">
          <v-avatar class="my-2" size="90" tile>
            <v-img :src="item.src"></v-img>
          </v-avatar>
          <v-card-title class="subtitle-1 px-0 pt-3">{{item.title}}</v-card-title>
        </div>
        <div class="help" @click="helpDialog">
          <v-icon>help</v-icon>
        </div>
      </v-card>
    </v-col>
    <v-col v-if="isShowIncome" cols="12" class="pt-2 px-2 subtitle">Income and Expense</v-col>
    <v-col v-for="(item, i) in incomeMeuns" :key="i-99" cols="6" sm="6" md="3" lg="2" class="pa-1">
      <v-card :color="item.color" dark>
        <div class="d-flex pointer" @click="changeRouter(item.value)">
          <v-avatar class="my-2" size="90" tile>
            <v-img :src="item.src"></v-img>
          </v-avatar>
          <v-card-title class="subtitle-1 px-0 pt-3">{{item.title}}</v-card-title>
        </div>
        <div class="help" @click="helpDialog">
          <v-icon>help</v-icon>
        </div>
      </v-card>
    </v-col>
    <v-col v-if="isShowStatement" cols="12" class="pt-2 px-2 subtitle">Statement</v-col>
    <v-col v-for="(item, i) in statement" :key="i-999" cols="6" sm="6" md="3" lg="2" class="pa-1">
      <v-card :color="item.color" dark>
        <div class="d-flex pointer" @click="changeRouter(item.value)">
          <v-avatar class="my-2" size="90" tile>
            <v-img :src="item.src"></v-img>
          </v-avatar>
          <v-card-title class="subtitle-1 px-0 pt-3" v-html="item.title"></v-card-title>
        </div>
        <div class="help" @click="helpDialog">
          <v-icon>help</v-icon>
        </div>
      </v-card>
    </v-col>
    <v-col v-if="isShowReport" cols="12" class="pt-2 px-2 subtitle">Reports</v-col>
    <v-col v-for="(item, i) in report" :key="i-9999" cols="6" sm="6" md="3" lg="2" class="pa-1">
      <v-card :color="item.color" dark>
        <div class="d-flex pointer" @click="changeRouter(item.value)">
          <v-avatar class="my-2" size="90" tile>
            <v-img :src="item.src"></v-img>
          </v-avatar>
          <v-card-title class="subtitle-1 px-0 pt-3" v-html="item.title"></v-card-title>
        </div>
        <div class="help" @click="helpDialog">
          <v-icon>help</v-icon>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
// import a from "../assets/logo.png"
export default {
  name: "home",
  data() {
    return {
      items: [
        {
          color: "#1F7087",
          src: "https://cdn.vuetifyjs.com/images/cards/foster.jpg",
          title: "Supermodel",
          artist: "Foster the People",
        },
        {
          color: "#952175",
          src: "https://cdn.vuetifyjs.com/images/cards/halcyon.png",
          title: "Halcyon Days",
          artist: "Ellie Goulding",
        },
      ],
      report: [],
      statement: [],
      order: [],
      incomeMeuns: [],
      isShowIncome: true,
      isShowStatement: true,
      isShowReport: true,
    };
  },
  props: {
    hideToolbar: Function,
  },
  mounted: function () {
    this.$nextTick(() => {
      this.hideToolbar(false);
    });
    this.userType = this.$store.state.userAccount.role;
    if (this.userType == "DELIVERY") {
      this.order = [
        {
          title: "Order List",
          icon: "assignment_turned_in",
          value: "/order/list/process",
          color: "#b6d02e",
          src: "info/orderList.png",
        },
        
      ];
      this.isShowStatement = false;
      this.isShowIncome = false;
      this.isShowReport = false;
    }else if (this.userType == "MARKETING") {
          this.$router.replace("/onlineshopping").catch(() => {});
        }else {
      this.statement = [
        {
          title: "Debtor / <br> Creditor",
          value: "/debtorAndcreditor",
          color: "#b6d02e",
          src: "info/debtorcreditor.png",
        },
        {
          title: "OS Detail",
          value: "/onlineDetailStatement",
          color: "#b6d02e",
          src: "info/osDetail.png",
        },
        {
          title: "Delivery",
          value: "/deliveryStatement",
          color: "#b6d02e",
          src: "info/deliveryStatement.png",
        },
      ];
      this.incomeMeuns = [
        {
          title: "Payment",
          value: "/payment",
          color: "#b6d02e",
          src: "info/payment.png",
        },
        {
          title: "Income",
          value: "/income",
          color: "#b6d02e",
          src: "info/income.png",
        },
        {
          title: "Expense",
          value: "/expense",
          color: "#b6d02e",
          src: "info/expense.png",
        },
      ];
      this.order = [
        {
          title: "New Order",
          value: "/order/manage",
          color: "#b6d02e",
          src: "info/newOrder.png",
        },
        // {
        //   title: "Group Order",
        //   value: "/order/manageMultiple",
        //   color: "#b6d02e",
        //   src: "info/groupOrdered.png",
        // },
        // {
        //   title: "Todo List",
        //   value: "/order/list",
        //   color: "#b6d02e",
        //   src: "info/toDoList.png",
        // },
        {
          title: "Order List",
          value: "/order/list/process",
          color: "#b6d02e",
          src: "info/orderList.png",
        },
        // {
        //   title: "Task List",
        //   value: "/task",
        //   color: "#b6d02e",
        //   src: "info/taskList.png",
        // },
        // {
        //   title: "Order Os",
        //   value: "/order/os",
        //   color: "#b6d02e",
        //   src: "info/orderos.png",
        // },
      ];
      this.report = [
        {
          title: "Complete <br> Report",
          value: "/completeReport",
          color: "#b6d02e",
          src: "info/completeReport.png",
        },
        {
          title: "Sale Report",
          value: "/saleReport",
          color: "#b6d02e",
          src: "info/saleReport.png",
        },
        // {
        //   title: "Advance Paid <br> Report",
        //   value: "/advanceReport",
        //   color: "#b6d02e",
        //   src: "info/advance-report.png",
        // },
        {
          title: "Income Report",
          value: "/incomeReport",
          color: "#b6d02e",
          src: "info/incomeReport.png",
        },
        {
          title: "Expense Report",
          value: "/expenseReport",
          color: "#b6d02e",
          src: "info/incomeReport.png",
        },
        {
          title: "Profit And Loss",
          value: "/profitAndLoss",
          color: "#b6d02e",
          src: "info/incomeReport.png",
        },
      ];
    }
  },
  methods: {
    helpDialog: function () {
      console.log("object");
    },
    changeRouter: function (path) {
      if (path == "logout") {
        this.$store.commit("updateUserAccount", {
          userName: "",
          password: "",
          role: "",
        });
        this.$router.push({
        path: path,
      });
      }else if (path == "/order/manage"){
         this.$router
        .push({
          name: "manage-order",
          query: {
            itemId: 0,
            step: 1
          },
        })
        .catch(() => {});
      } else if (path == "/order/manageMultiple"){
        this.$router
        .push({
          name: "manage-order-multiple",
          query: {
            itemId: 0,
            step: 1
          },
        })
        .catch(() => {});
      }else{
        this.$router.push({
        path: path,
      });
      }

      
      // if (path == "notification") {
      //   this.getNotifactionCount();
      // }
    },
  },
};
</script>
<style scoped>
.help {
  cursor: help;
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 3px;
}
.pointer {
  cursor: pointer;
}
.login-full {
  height: 93vh;
}
</style>
